(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertice-sale-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-v-sale-popup]');
    if (!popup) return;

    const key = 'vertice-last-units-sale-popup-v2';
    let dismissed = false;

    try {
      dismissed = sessionStorage.getItem(key) === '1';
    } catch (error) {}

    if (dismissed) return;

    const showPopup = () => {
      popup.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => popup.classList.add('is-visible'));
      });
    };

    const timer = window.setTimeout(showPopup, 850);
    const closeButton = popup.querySelector('[data-v-sale-close]');

    const closePopup = () => {
      window.clearTimeout(timer);
      popup.classList.remove('is-visible');

      try {
        sessionStorage.setItem(key, '1');
      } catch (error) {}

      window.setTimeout(() => {
        popup.hidden = true;
      }, 280);
    };

    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closePopup();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
